import { render, staticRenderFns } from "./InputIndex.vue?vue&type=template&id=bcaa2cd0"
import script from "./InputIndex.vue?vue&type=script&lang=js"
export * from "./InputIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports